export class TopMenuItem{
    Key: String
    Label: String  
    LinkUrl:String 
    isVisible: Boolean = true;   
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/models/top-menu-item.model.ts